import { createContext } from 'react';
import type { ICompletionTarget } from '@organisms/document/DocumentCompletionNavigator/completion.types';

export type DocumentTableNavigator = (
    target: ICompletionTarget,
    isCurrent: () => boolean,
) => Promise<{ nextPath?: string; message?: string }>;

export interface IDocumentFieldNavigationRegistry {
    register: (path: string, navigate: DocumentTableNavigator) => () => void;
}

export const DocumentFieldNavigationContext = createContext<IDocumentFieldNavigationRegistry | null>(null);
